import z from "zod";

// WebHook schema validation
export const webhookSchema = z.object({
  _id: z
    .string()
    .regex(/^[0-9a-fA-F]{24}$/, "Invalid webhook ID")
    .optional(),
  name: z
    .string()
    .min(1, { message: "Name is required" })
    .max(100, { message: "Name must be less than 100 characters" }),
  workspaceId: z.string().regex(/^[0-9a-fA-F]{24}$/, "Invalid workspace ID"),
  active: z.boolean(),
  apiEndpoint: z
    .string()
    .refine(
      (value) =>
        /^(https?):\/\/(?=.*\.[a-z]{2,})[^\s$.?#].[^\s]*$/i.test(value),
      {
        message: "Please enter a valid URL",
      }
    ),
  requestType: z.enum(["GET", "POST", "PUT", "DELETE"]),
  triggers: z
    .array(
      z.object({
        type: z.string(),
        functions: z.array(z.enum(["Create", "Save", "Delete"])),
      })
    )
    .min(1, {
      message: "At least one trigger is required",
    }),
  filters: z
    .array(
      z.object({
        field: z.string(),
        operator: z.string(),
        value: z.union([
          z.string(),
          z.coerce.number(),
          z.array(z.string()),
          z.null(),
        ]),
      })
    )
    .optional(),
  headers: z
    .array(
      z.object({
        key: z.string(),
        value: z.string(),
      })
    )
    .optional(),
  payload: z.json().optional(),
});
